import React from 'react';
import { Box, Stack, Typography, TypographyProps } from '@mui/material';
import moment from 'moment';
import {
  StyledTableCell,
  StyledTableRow,
} from '../../../../../components/V2/Table/type1/TableStyles';
import {
  getSubmissionsV2State,
  ITopicSubmission,
} from '../../../../../store/V2/SubmissionsSlice';
import { TP_COLORS } from '../../../../../constants';
import { msToMinutesSeconds } from '../../../../../helper';
import { useAppSelector } from '../../../../../hooks';
import {
  getScoreColor,
  getScoreStatus,
  getTimeIcon,
} from '../../DetailedOverview/components/SubmissionTableRow';

const typoProps: TypographyProps = {
  fontSize: '14px',
  color: TP_COLORS.gray.darken,
};

interface ISubmissionTableRowProps {
  rowData: ITopicSubmission;
}

const SubmissionTableRow: React.FC<ISubmissionTableRowProps> = ({
  rowData,
}) => {
  // Store
  const { courseSubmissionsData } = useAppSelector(getSubmissionsV2State);

  const courseAverageTime = courseSubmissionsData?.totalAverageTime || 0;

  const latestSubmissionAt = moment(rowData.submissions[0].createdAt);
  let topicAverageScore = 0;

  if (courseSubmissionsData?.groupedSubmissions) {
    const selectedTopic = courseSubmissionsData.groupedSubmissions.find(
      (topic) => topic.topicName === rowData.topicName
    );

    if (selectedTopic) {
      topicAverageScore = selectedTopic.averageScore;
    }
  }

  const timeDif = courseAverageTime - rowData.averageTime;

  return (
    <StyledTableRow key={rowData.topicId}>
      <StyledTableCell component="th" scope="row">
        {rowData.topicName}
      </StyledTableCell>
      <StyledTableCell>
        <Stack>
          <Typography {...typoProps}>
            {latestSubmissionAt.format('ddd MMM DD YYYY')}
          </Typography>
          <Typography fontSize="12px" color="#94A3B8">
            {latestSubmissionAt.format('hh:mm A')}
          </Typography>
        </Stack>
      </StyledTableCell>
      <StyledTableCell>
        <Stack>
          <Typography {...typoProps}>{rowData.averageScore}/20</Typography>
          <Typography
            fontSize="12px"
            color={getScoreColor(rowData.averageScore, topicAverageScore)}
          >
            {getScoreStatus(rowData.averageScore, topicAverageScore)}
          </Typography>
        </Stack>
      </StyledTableCell>
      <StyledTableCell>
        <Stack>
          <Typography {...typoProps}>
            {msToMinutesSeconds(rowData.averageTime)}
          </Typography>
          {timeDif !== 0 && (
            <Box
              display="flex"
              alignItems="center"
              color={getScoreColor(courseAverageTime, rowData.averageTime)}
            >
              {getTimeIcon(timeDif)}
              <Typography fontSize="12px" marginLeft="2px">
                {msToMinutesSeconds(Math.abs(timeDif))}
              </Typography>
            </Box>
          )}
        </Stack>
      </StyledTableCell>
    </StyledTableRow>
  );
};

export default SubmissionTableRow;
